export default __webpack_public_path__ + "static/media/header-services.da9975ad.jpg";